<template>
  <div class="video-box" :style="`padding: ${padding};`">
    <div class="video-in">
      <video
        :id="`my-video${id}`"
        class="my-video video-js vjs-default-skin vjs-big-play-centered"
        controls
        :poster="poster"
        :width="width"
        preload="auto"
      >
        <!--  src="https://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/2023/m3u8/2023/09/08/14e05097/m3u8.m3u8" -->
        <source
          :src="liveAddress"
          type="application/x-mpegURL"
        />
      </video>
    </div>
  </div>
</template>

<script>
import { getLiveInfo } from '@/api/api.js'
import videojs from 'video.js'
import 'videojs-contrib-hls'
import { mapGetters } from 'vuex'
import { nanoid } from 'nanoid'
export default {
  data() {
    return {
      player: null,
      isTrue: true,
      timer: null,
      id: null,
      liveAddress: []
    }
  },
  computed: {
    ...mapGetters(['liveState'])
  },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    isPlay: {
      type: Boolean,
      default: false
    },
    liveInfo: {
      type: Object,
      default: () => {
        return {
          live: {},
          liveStream: {}
        }
      }
    },
    poster: {
      type: String,
      default:
        // 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_d603dd59fb7042e98e2318147231d4be.png'
        // 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_6fdd3d7e1ed844cd8facdafa65a42635.png'
        // 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_11c18cbcd8d645cf860a13690d07fd3b.jpg'
        'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_47ce31191ae0442a8e58a4382c70765a.png'
    },
    padding: {
      type: String,
      default: ''
    }
  },
  watch: {
    poster(n) {
      if (this.player) {
        this.player.setAttribute('poster', n)
      }
    }
  },
  created() {
    this.getLiveInfo(1777)
  },
  mounted() {
    this.id = nanoid()
    this.$nextTick(() => {
      setTimeout(() => {
        this.getVideo()
      }, 100)
    })
  },
  methods: {
    getLiveInfo(id) {
      const data = { openId: 'openId' }
      getLiveInfo(data, id).then((res) => {
        this.liveAddress = res.data.liveStream.defaultAddress
        this.poster = res.data.live.kvImg
      })
    },
    getVideo() {
      this.player = videojs(
        `my-video${this.id}`,
        {
          bigPlayButton: true, // 显示播放按钮
          textTrackDisplay: false,
          posterImage: true,
          errorDisplay: false,
          controlBar: true // 显示控件
        },
        (that) => {
          // this.player.src({
          //   src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/08/23/3edfe750/m3u8.m3u8',
          //   type: 'application/x-mpegURL',
          //   withCredentials: true
          // })
          this.player.on('play', () => {
            this.$emit('update:isPlay', true)
          })
        }
      )
    },
    play(src) {
      // this.player.src(src)
      this.player.play()
    },
    pause() {
      this.player.pause()
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
      this.player = null
    }
  }
}
</script>

<style lang="scss" scoped>
.video-box {
  // position: absolute;
  width: 100%;
  height: 100%;
  // top: 0;
  // left: 0;
  box-sizing: border-box;
  .video-in {
    display: flex;
    width: 100%;
    height: 100%;
    position: relative;
  }
  .my-video {
    margin: auto;
    width: 100%;
    height: 100%;
  }
  ::v-deep .video-js .vjs-big-play-button {
    font-size: 6em !important;
    color: rgba(255, 255, 255, 0.5) !important;
    background: none;
    border: none;
  }
}
.video-kv {
  width: 100%;
  height: 100%;
  z-index: 999;
  position: absolute;
  top: 0;
  left: 0;
  img {
    width: 100%;
    height: 100%;
  }
}
::v-deep .vjs-poster {
  background-size: 100% 100% !important;
}
.swiper-button-next,
.swiper-button-prev {
  margin-top: calc(0px - (var(--swiper-navigation-size) / 1.2)) !important;
}
</style>
